export enum FormStatus {
  INITIAL = 'Initial',
  SENT = 'Sent',
  FINISHED = 'Finished',
  CLOSED = 'Closed',
  /** The reset link (or session token) was rejected: a new link is needed. */
  EXPIRED = 'Expired',
}
